import { TitleText } from 'text/part'
import { Photo } from './types'

const PhotoArticle: Photo = {
  title: TitleText.photo,
  tiles: [
    {
      img: 'nakata.jpg',
      title: { jp: '中田です(昭和感)', en: 'nakata' },
      cols: 1,
    },
    {
      img: 'nakata_guitar.jpg',
      title: { jp: 'ギターです', en: 'with guitar' },
      cols: 1,
    },
  ],
}

export default PhotoArticle
